import { useSectionTranslation } from '@/hooks';
import { useDocumentTitle } from '@/hooks';
import { Header } from '../Header';
import { Hero } from '../Hero';
import { StatsStrip } from '../StatsStrip';
import { FeaturedListings } from '../FeaturedListings';
import { CategoryGrid } from '../CategoryGrid';
import { PaymentMethods } from '../PaymentMethods';
import { TrustStrip } from '../TrustStrip';
import { SellerTrust } from '../SellerTrust';
import { Footer } from '../Footer';
import { useMarketplaceHome } from '../useMarketplaceHome';
import { homePageTranslations } from './translations';

export function HomePage() {
  const t = useSectionTranslation(homePageTranslations);
  useDocumentTitle(t.title);
  const { data, loading } = useMarketplaceHome();

  return (
    <>
      <Header />
      <main>
        <Hero />
        <StatsStrip stats={data?.stats ?? null} />
        <FeaturedListings
          featured={data?.featured ?? []}
          recent={data?.recent ?? []}
          loading={loading}
        />
        <CategoryGrid categories={data?.categories ?? []} loading={loading} />
        <TrustStrip />
        <SellerTrust />
        <PaymentMethods />
      </main>
      <Footer />
    </>
  );
}
